/* eslint-disable linebreak-style */
/* eslint-disable quotes */
import React, { useState } from "react";
import PropTypes from "prop-types";
import ContactDetailsMissing from './ContactDetailsMissing';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from 'react-i18next';

const ClientsList = ({
  clients,
  onEdit,
  showArchivedClients,
  initialNumToShow,
  onNumToShowChange,
}) => {
  const { t: tr } = useTranslation();
  const [numToShow, setNumToShow] = useState(initialNumToShow || 25);

  const updateNumToShow = (nextValue) => {
    setNumToShow(nextValue);
    onNumToShowChange(nextValue);
  };

  const handleShowMore = () => {
    updateNumToShow(numToShow + 25);
  };

  const handleShowAll = () => {
    updateNumToShow(clients.length);
  };

  const visibleClients = showArchivedClients ? clients : clients.filter((client) => !client.archived);

  return (
    <div>
      <div className="">
        <div className="row table-header manage-table-title text-center mx-0">
          <div className="col-5">
            <div className="row d-flex">
              <div className="col-md-5 pr-0 pr-md-3 table-cell">{tr("manage:firstName_156")}</div>
              <div className="col-md-7 pr-0 pr-md-3 table-cell">{tr("common:lastName")}</div>
            </div>
          </div>
          <div className="col-5 col-md-6">
            <div className="row d-flex">
              <div className="col-md-6 table-cell">{tr("common:phone")}</div>
              <div className="col-md-6 table-cell">{tr("common:email")}</div>
            </div>
          </div>
          <div className="col-2 col-md-1 p-0 d-flex align-items-center justify-content-center">
            <i className="fas fa-flag fa-lg" />
          </div>
        </div>
        <div className="">
          {visibleClients.slice(0, numToShow).map((client, index) => (
            <div key={client.id}>
              <div
                className={`table-row row d-flex manage-text text-center cursor-pointer mx-0 ${
                  index % 2 !== 0 ? "table-row-alternate" : ""
                }`}
                onClick={() => onEdit(client)}
              >
                <div className="col-5">
                  <div className="row d-flex">
                    <div className="col-md-5 pr-0 pr-md-3 table-cell">
                      {client.firstName}
                    </div>
                    <div className="col-md-7 pr-0 pr-md-3 table-cell">
                      {client.lastName}
                    </div>
                  </div>
                </div>
                <div className="col-5 col-md-6">
                  <div className="row d-flex">
                    <div className="col-md-6 table-cell">{client.mobile}<ContactDetailsMissing field="mobile" mobile={client.mobile} /></div>
                    <div className="col-md-6 table-cell">{client.email}<ContactDetailsMissing field="email" email={client.email} /></div>
                  </div>
                </div>
                <div className="col-2 col-md-1 p-0 d-flex align-items-center justify-content-center table-cell">
                  {client.notes && (
                    <OverlayTrigger
                      overlay={<Tooltip>{client.notes}</Tooltip>}
                    >
                      <i className="fas fa-flag fa-lg" />
                    </OverlayTrigger>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="pt-3 row d-flex justify-content-center mx-0">

          {numToShow < visibleClients.length && (
            <div className="col-md-3 form-group">
              <button
                type="button"
                className="btn manage-button manage-red-button btn-block"
                onClick={handleShowMore}
              >{tr("manage:showMore_73")}</button>
            </div>
          )}
          {numToShow < visibleClients.length && (
            <div className="col-md-3 form-group">
              <button
                type="button"
                className="btn manage-button btn-dark btn-block"
                onClick={handleShowAll}
              >{tr("manage:showEveryone_157")}</button>
            </div>
          )}
      </div>
    </div>


  );
};

ClientsList.propTypes = {
  clients: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string,
      mobile: PropTypes.string,
    })
  ).isRequired,
  onEdit: PropTypes.func.isRequired,
  showArchivedClients: PropTypes.bool,
  initialNumToShow: PropTypes.number,
  onNumToShowChange: PropTypes.func,
};

ClientsList.defaultProps = {
  showArchivedClients: false,
  initialNumToShow: 25,
  onNumToShowChange: () => {},
};

export default ClientsList;
